import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLineChart = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 10,
	viewBox: "0 0 19 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.75 8.83673L1.35764 8.05547C2.85724 6.12742 4.73082 4.52214 6.86601 3.33593C7.13001 3.18926 7.46238 3.26984 7.6299 3.52112L10.3063 7.53571C10.4784 7.79392 10.8336 7.85156 11.0786 7.66104C13.2131 6.0009 14.9127 3.84753 16.0317 1.38583L16.2994 0.796797M17.4167 4.64825C17.2657 3.3956 16.9509 2.16867 16.4806 0.998867C16.4448 0.909759 16.3795 0.839601 16.2994 0.796797M12.428 1.76803C13.5883 1.27241 14.8082 0.931589 16.0565 0.75399C16.1424 0.741759 16.227 0.758099 16.2994 0.796797",
		stroke: "#18181B",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgLineChart);
export default ForwardRef;
